import moment from "moment";
import ImageProcessor from "./imageProcessor";
import { fabric } from "fabric";
import axios from "axios";
import Cookies from "js-cookie";

export const camelize = (string: string): string => {
  return string
    .split(" ")
    .map((word, index) =>
      index === 0 ? word.toLowerCase() : word[0].toUpperCase() + word.slice(1)
    )
    .join("");
};

export const getDate = (date: string): string => {
  if (!date) return "";
  return date.split("T")[0];
};

export const getCurrencyPrice = (price: number, currency: string): string => {
  price = price ? price : 0;
  switch (currency) {
    case "dollar": {
      return `$${price}`;
    }
    case "pound": {
      return `£${price}`;
    }
    case "euro": {
      return `€${price}`;
    }

    default: {
      return `$${price}`;
    }
  }
};

export const parseJwt = (token: string) => {
  if (!token) {
    return;
  }
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  return JSON.parse(window.atob(base64));
};

type MarkArea = {
  xAxis: number;
};

export const getMarkAreaData = (data: string[] | number[]): MarkArea[][] =>
  data.map((el, index) => [
    {
      xAxis: 2 * index,
    },
    {
      xAxis: 2 * index + 1,
    },
  ]);

export const capitalize = (word: string): string =>
  `${word[0].toUpperCase()}${word.slice(1)}`;

export const hexToRGB = (hex: string, alpha: string | number): string => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  return alpha ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgb(${r}, ${g}, ${b})`;
};

export const getDifference = (
  value: number,
  prevValue: number
): string | null =>
  prevValue !== 0
    ? `${((Math.abs(value - prevValue) / prevValue) * 100).toFixed(0)}%`
    : "100%";

export const normalizeProp = (
  prop: string | number | [number, number]
): string =>
  typeof prop === "number"
    ? `${prop}px`
    : (Array.isArray(prop) && `${prop[0]}px ${prop[1]}px`) || prop.toString();

// export const defineColorByPriority = (priority: Priority, theme: DefaultTheme): string => {
//   switch (priority) {
//     case Priority.INFO:
//       return theme.colors.main.primary;
//     case Priority.LOW:
//       return theme.colors.main.success;
//     case Priority.MEDIUM:
//       return theme.colors.main.warning;
//     case Priority.HIGH:
//       return theme.colors.main.error;
//     default:
//       return theme.colors.main.success;
//   }
// };

// export const defineColorBySeverity = (severity: NotificationType | undefined, theme: DefaultTheme): string => {
//   switch (severity) {
//     case 'error':
//       return theme.colors.main.error;
//     case 'warning':
//       return theme.colors.main.warning;
//     case 'success':
//       return theme.colors.main.success;
//     case 'info':
//       return theme.colors.main.primary;
//     default:
//       return theme.colors.main.primary;
//   }
// };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mergeBy = (a: any[], b: any[], key: string): any[] =>
  a
    .filter((elem) => !b.find((subElem) => subElem[key] === elem[key]))
    .concat(b);

export const getSmoothRandom = (factor: number, start: number): number => {
  const halfEnvelope = 1 / factor / 2;
  const max = Math.min(1, start + halfEnvelope);
  const min = Math.max(0, start - halfEnvelope);

  return Math.random() * (max - min) + min;
};

export const trimStr = (str: string, charCount = 15) => {
  if (!str) return "";
  var res = str.substring(0, charCount);
  return res + "...";
};

export const getDateAndTime = (date: string) => {
  if (!date) {
    return "";
  }
  const isoDate = date;
  const formattedDate = moment(isoDate).format("MMMM Do YYYY, h:mm a");
  return formattedDate;
};

export const toAbsoluteUrl = (pathname: string) =>
  process.env.PUBLIC_URL + pathname;

export const applyEffectToImage = async (
  // selectedObjectImage: string,
  // selectedEffect: any,
  // selectedHalftone: any,
  // invertColor: any,
  // hexToRgb: any,
  // thresholdLevel: any = 160,
  // darkColorRgb: any = { red: 0, green: 0, blue: 0 },
  // lightColorRgb: any = { red: 255, green: 255, blue: 255 },
  // removeWhite: any = false,
  // overlayImage: any = null,
  // overlayOpacity: any = 1,
  // overlayColorEnabled: any = false
  selectedEffectData: any
) => {
  const {
    selectedObjectImage,

    fabric,
  } = selectedEffectData;

  if (!selectedEffectData.selectedEffect) {
    return new Promise((resolve, rej) => {
      resolve(selectedObjectImage);
    });
  }
  /**
   * {
    "id": 6,
    "name": "First900909",
    "blend_mode": "normal",
    "is_adjustment": true,
    "opacity": 100,
    "text_overlay_color": "true",
    "text_color": "#db0707",
    "image_effect": "contrasted greyscale",
    "image_halftone": "1",
    "image_is_invert_color": true,
    "image_is_overlay_color": true,
    "image_overlay_color": "#961b1b",
    "image_threshold_value": 160,
    "image_is_dark_color": false,
    "image_is_light_color": false,
    "image_dark_color": "null",
    "image_light_color": "null",
    "image_remove_white": false,
    "image_overlay_image": "https://imagedelivery.net/ZFpmFfUMgrq3swZTSeGQxA/d2caed1c-1269-4e96-b94e-16f86cf94f00/original",
    "image_overlay_opacity": 44,
    "is_predefined": false,
    "createdDate": "2024-07-01T15:48:28.000Z",
    "updatedDate": "2024-07-01T15:48:28.000Z"
}
   */
  const {
    image_effect: selectedEffect,
    image_halftone: selectedHalftone,
    image_is_invert_color: invertColor,
    image_is_overlay_color: overlayColorEnabled,
    image_overlay_color: hexToRgb,
    image_threshold_value: thresholdLevel,
    image_is_dark_color: darkColorRgb,
    image_is_light_color: lightColorRgb,
    image_remove_white: removeWhite,
    image_overlay_image: overlayImage,
    image_overlay_opacity: overlayOpacity,
  } = selectedEffectData.selectedEffect;

  debugger;
  let blob = null;
  let imageUrl = selectedObjectImage;

  switch (selectedEffect) {
    case "none":
      blob = null;
      break;
    case "greyscale":
      blob = await ImageProcessor.greyScale(
        imageUrl,
        selectedHalftone,
        invertColor,
        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined
      );
      break;
    case "contrasted greyscale":
      blob = await ImageProcessor.greyScalePlus(
        imageUrl,
        selectedHalftone,
        invertColor,
        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined
      );
      break;
    case "soft greyscale":
      blob = await ImageProcessor.desaturate(
        imageUrl,
        selectedHalftone,
        invertColor,
        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined
      );
      break;
    case "hard greyscale":
      blob = await ImageProcessor.blackAndWhite(
        imageUrl,
        selectedHalftone,
        invertColor,
        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined
      );
      break;
    case "black and white":
      blob = await ImageProcessor.thresholding(
        imageUrl,

        thresholdLevel,
        invertColor,
        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined
      );
      break;
    case "black and transparent":
      blob = await ImageProcessor.thresholdingTransparentWhite(
        imageUrl,
        thresholdLevel,
        invertColor,
        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined
      );
      break;
    case "dark and light":
      blob = await ImageProcessor.thresholdingDarkAndLight(
        imageUrl,

        thresholdLevel,
        invertColor,
        darkColorRgb,
        lightColorRgb
      );
      break;
    case "silhouette":
      blob = await ImageProcessor.overlapColor(
        imageUrl,

        overlayColorEnabled
          ? hexToRgb && hexToRgb.r
            ? { red: hexToRgb.r, green: hexToRgb.g, blue: hexToRgb.b }
            : hexToRgb
          : undefined,
        removeWhite
      );
      break;
    default:
      break;
  }
  if (blob) {
    debugger;
    let url = await blobObjToBase64(blob);
    url = url
      ? await ImageProcessor.generateBlendedImage(
          url,
          overlayImage,
          overlayOpacity,
          fabric as any
        )
      : url;
    return url;
  } else {
    let imageUrl = overlayImage
      ? await ImageProcessor.generateBlendedImage(
          selectedObjectImage,
          overlayImage,
          overlayOpacity,
          fabric as any
        )
      : selectedObjectImage;
    return imageUrl;
  }
};

/**
 *   const handleUpdateText = async (textProps: {
    color?: string;
    text?: string;
    overlayImage?: string;
  }) => {
    let overlayImage: any = textProps.overlayImage
      ? await getOverlayImageAsAString(textProps.overlayImage)
      : null;
    fabricCanvasRef.current?.updateText({
      fill: textProps?.color || "#000",
      text: textProps?.text || "Sample Text",
      pattern: overlayImage,
    });
  };
 */
export const getOverlayImageAsAString = (file: any) => {
  return new Promise((resolve, reject) => {
    if (typeof file === "object" && file !== null) {
      const reader = new FileReader();
      reader.onload = async (e: any) => {
        const blob = e.target
          ? await fetch(e.target.result).then((res) => res.blob())
          : null;
        const url = blob ? URL.createObjectURL(blob) : null;
        resolve(url);
      };
      reader.readAsDataURL(file);
    } else {
      if (file && file !== null && file !== undefined) {
        resolve(file);
      } else {
        resolve(null);
      }
    }
  });
};

export const blobToBase64 = async (blobUrl: string) => {
  try {
    const response = await axios.get(blobUrl, {
      responseType: "blob",
    });

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(response.data);
    });
  } catch (error) {
    console.error("Error converting Blob to Base64:", error);
    throw error; // Propagate the error
  }
};

export const blobObjToBase64 = async (blob: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const base64data = reader.result;
      resolve(base64data);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(blob);
  });
};
export const getTempCart = () => {
  const cartData = localStorage.getItem("tempCart");
  if (cartData) {
    const parsedData = JSON.parse(cartData);
    const currentTime = new Date().getTime();

    // Check if the item has expired
    if (parsedData.expiresAt && currentTime > parsedData.expiresAt) {
      localStorage.removeItem("tempCart"); // Remove expired item
      return null;
    }
    return cartData;
  }
  return null;
};

export const checkAndCreateSessionIdFromCookie = () => {
  // PRIORITY #1: Check if there's Shopify customer data in the global window object
  const shopifyCustomer = (window as any).Shopify && (window as any).Shopify.customer;
  if (shopifyCustomer && shopifyCustomer.id) {
    // Use Shopify customer ID directly - best identifier
    console.log("shopifyCustomer", shopifyCustomer);
    console.log("shopifyCustomer.id", shopifyCustomer.id);
    console.log("shopifyCustomer.email", shopifyCustomer.email);
    return shopifyCustomer.id.toString();
  }

  // PRIORITY #2: Check for Shopify visitor cookies
  // const shopifyVisitorToken = Cookies.get('_shopify_y') || Cookies.get('_shopify_s');
  const shopifyVisitorToken = Cookies.get('_shopify_y');
  const shopifySessionToken = Cookies.get('_shopify_s');
  const cartToken = Cookies.get('cart');
  console.log("shopifyVisitorToken", shopifyVisitorToken);    
  console.log("shopifySessionToken", shopifySessionToken);
  console.log("cartToken", cartToken);
  if (shopifyVisitorToken || cartToken) {
    return shopifyVisitorToken || cartToken;
    
  }
  
  // PRIORITY #3: Fall back to our existing session ID or create new one
  let sessionId = Cookies.get("User_Session_ID");
  if (!sessionId) {
    // Generate a more robust ID with timestamp for better uniqueness
    sessionId = Math.random().toString(36).substring(2, 15);
    localStorage.setItem("user-uploaded-image", "");
    Cookies.set("User_Session_ID", sessionId, { expires: 90 });
    Cookies.set("User_Session_Count", "1", { expires: 90 });
  }
  console.log("sessionId", sessionId);
  return sessionId;
};

// export const checkAndCreateSessionIdFromCookie = () => {
//   let sessionId = Cookies.get("User_Session_ID");
//   if (!sessionId) {
//     sessionId = Math.random().toString(36).substring(2, 15);
//     localStorage.setItem("user-uploaded-image", "");
//     Cookies.set("User_Session_ID", sessionId, { expires: 90 });
//     Cookies.set("User_Session_Count", "1", { expires: 90 });
//   }
//   return sessionId;
// };

export const saveSelectedColorsToCookie = (
  sessionId: any,
  selectedColors: any,
  productId: any
) => {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 7); // Set expiration to 7 days from now

  const cartData = {
    sessionId,
    selectedColors,
    expiresAt: expirationDate.getTime(), // Store expiration as timestamp
  };
  localStorage.setItem("tempCart", JSON.stringify(cartData));
};

export const storeUserIdInCookie = (userId: string) => {
  Cookies.set("userId", userId, { expires: 30 });
  localStorage.setItem("userId", userId);
  
  // Also associate with the current session
  const sessionId = checkAndCreateSessionIdFromCookie();
  
  // Update the tempCart if it exists
  const cartData = getTempCart();
  if (cartData) {
    try {
      const parsedData = JSON.parse(cartData);
      parsedData.userId = userId;
      localStorage.setItem("tempCart", JSON.stringify(parsedData));
    } catch (e) {
      console.error("Error updating cart data", e);
    }
  }
  
  return { sessionId, userId };
};
